import React, { useEffect, useState } from 'react';
import LinkButton from '../button/LinkButton';
import ItemList from '../list/ItemList';
import { fetchAllIntegrations } from '../../api/IntegrationApi';
import { Integration } from '../model';

const Integrations: React.FC = () => {
  const [integrations, setIntegrations] = useState<Integration[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchAllIntegrations()
      .then(setIntegrations)
      .catch(() => setError('Failed to load integrations'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return (
    <>
      <div className="header-container">
        <LinkButton label="Create Integration" link="/integration" />
      </div>
      <ItemList
        items={integrations}
        linkPrefix="integration"
        renderName={integration => integration.name}
        renderStatus={integration => integration.status!}
      />
    </>
  );
};

export default Integrations;
